module.exports = __webpack_public_path__ + "static/img/white_lion_laying_down_1024x683.bed21d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/white_lion_laying_down_1024x683.jpg
// module id = RVoE
// module chunks = 0